import React, { useEffect, useState, useRef } from 'react';
import { Box, Button } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'dva';
import { useLocation, history } from 'umi';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import AddVoucherEdit from './components/AddVoucherEdit';
import { OPT_DETAIL } from '@/constants';
import AddVoucherEditStyled from './AddVoucherEditStyles';

export default () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { query } = location;
  const { id, opt, sourceOid } = query;
  const saveRef = useRef();
  const { handleSubmit, control, setValue, watch, getValues, errors } =
    useForm();
  const watchAllFields = watch();
  const [isSubmit, setIsSubmit] = useState(false);
  //提交成功
  const handleSubmitSuccess = (data) => {
    if (isSubmit) {
      return false;
    }
    setIsSubmit(true);
    const values = id ? { ...data, id } : data;
    window.NE_DAWN.trigger(saveRef.current, {
      event: '_ec', // 事件名
      params: { ...values }, // 事件公参
    });
    dispatch({
      type: 'voucherEdit/editActivityCoupon',
      payload: {
        values,
      },
      callback: (res) => {
        if (res.code === 0) {
          history.goBack();
        } else {
          setIsSubmit(false);
        }
      },
    });
  };
  //提交失败
  const handleSubmitFail = () => {
    setIsSubmit(false);
  };

  useEffect(() => {
    if (!id) {
      return false;
    }
    dispatch({
      type: 'voucherEdit/getDetail',
      payload: {
        values: {
          id,
        },
      },
      callback: () => {},
    });
  }, [id, dispatch]);
  return (
    <AddVoucherEditStyled>
      <Box
        data-log={JSON.stringify({
          oid: 'page_marketing_activity_voucher_edit',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
            source: sourceOid,
          },
          events: ['_pv', '_pd'],
        })}
        height="100%"
      >
        <Box
          borderRadius="12px"
          bgcolor="background.paper"
          pt={3}
          pr={4}
          pb={4}
          pl={4}
        >
          <form onSubmit={handleSubmit(handleSubmitSuccess, handleSubmitFail)}>
            <AddVoucherEdit
              control={control}
              setValue={setValue}
              watchAllFields={watchAllFields}
              getValues={getValues}
              errors={errors}
            />
            <Box display="flex" gap="0 16px" pt={6}>
              {opt !== OPT_DETAIL && (
                <Button
                  data-log={JSON.stringify({
                    oid: 'btn_marketing_activity_voucher_edit_finish',
                    events: ['_ev'],
                    params: {
                      initUrl:
                        window.location.origin + window.location.pathname,
                      source: sourceOid,
                    },
                  })}
                  ref={saveRef}
                  variant="contained"
                  className="coupons-setting-button"
                  type="submit"
                  startIcon={
                    <DoneIcon sx={{ width: '16px', height: '16px' }} />
                  }
                >
                  完成
                </Button>
              )}
              <Button
                variant="contained"
                className="coupons-setting-button"
                color="secondary"
                onClick={() => {
                  history.goBack();
                }}
                startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
              >
                退出
              </Button>
            </Box>
          </form>
        </Box>
      </Box>
    </AddVoucherEditStyled>
  );
};
